import React, { Component } from 'react';
import { Row, Col, Table } from 'antd';
import moment from 'moment';

class PrintInventoryContent extends Component {
    render() {
        const {
            generateData, info, refillStartDate, refillDuration,
        } = this.props;

        const column = [
            {
                title: 'Id',
                dataIndex: 'id',
                key: 'id',
            }, {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            }, {
                title: 'Batch #',
                dataIndex: 'batch_number',
                key: 'batch_number',
            }, {
                title: 'Exp Date',
                dataIndex: 'expiry_date',
                key: 'expiry_date',
            }, {
                title: 'Pills',
                dataIndex: 'num_pills',
                key: 'num_pills',
            }, {
                title: 'Strip',
                dataIndex: 'num_strips',
                key: 'num_strips',
            }, {
                title: 'Per Strip',
                dataIndex: 'per_strip',
                key: 'per_strip',
            }, {
                title: 'Total',
                dataIndex: 'total_quantity',
                key: 'total_quantity',
            }, {
                title: 'Source',
                dataIndex: 'partner_location_name',
                key: 'partner_location_name',
            }, {
                title: 'Reason',
                dataIndex: 'reason',
                key: 'reason',
            },
        ];

        return (
            <div id="print-inventory-content" style={{ display: 'none' }}>
                <div style={{ textAlign: 'center' }}>
                    <Row type="flex" justify="space-around">

                        <Col span={8}>
                            <p style={{ color: 'black' }}>
                                Name -
                                {
                                    info.user != null
                                        ? `${info.user.first_name} ${info.user.last_name == null ? '' : info.user.last_name}`
                                        : ''
                                }
                            </p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Order/Refill ID - {info.id}</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Mobile – Contact Number - {info.user === undefined ? null : `${info.user.mobile_number} – ${info.user.contact_number}`}</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Partner Name + Location - {info.partner === undefined ? null : `${info.partner_location.name}`}</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Doctor's Name - {JSON.stringify(info.doctors)}</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Start Date - {moment(refillStartDate).format('DD-MM-YYYY')} ({moment(refillStartDate).format('dddd')})</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Refill Cycle Tenure - {refillDuration} Days</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Dispenser Size - {info.dispenser_size === undefined ? '' : info.dispenser_size}</p>
                        </Col>
                    </Row>
                </div>

                <hr />

                <h6 style={{ textAlign: 'center' }}>Dose information</h6>

                <Table
                    pagination={false}
                    dataSource={generateData}
                    className="printHead"
                    rowClassName="printColumn"
                    columns={column}
                    bordered
                    size="small"
                    style={{ whiteSpace: 'pre', outline: '1px solid black', fontSize: '7px' }}
                />

            </div>
        );
    }
}

export default PrintInventoryContent;



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/PrintInventoryContent.js